import { Link } from 'react-router-dom';
import type { VideoItem } from '@/mocks/videos';

interface VideoCardProps {
  video: VideoItem;
}

export default function VideoCard({ video }: VideoCardProps) {
  return (
    <Link
      to={`/article/${video.id}`}
      className="group block cursor-pointer"
    >
      <div className="relative aspect-[2/3] rounded-lg overflow-hidden bg-background-200 mb-3">
        <img
          src={video.cover}
          alt={video.title}
          title={`${video.title} - 桃花视频免费在线观看`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
          <span className="text-background-50 text-xs font-medium line-clamp-2">{video.description}</span>
        </div>
        <div className="absolute top-2 left-2 flex flex-col gap-1">
          {video.isHot && (
            <span className="px-2 py-0.5 bg-primary-500 text-background-50 text-xs font-medium rounded">热播</span>
          )}
          {video.isNew && (
            <span className="px-2 py-0.5 bg-accent-500 text-background-50 text-xs font-medium rounded">新上</span>
          )}
        </div>
        <div className="absolute top-2 right-2">
          <span className="px-2 py-0.5 bg-black/60 text-background-50 text-xs rounded">{video.rating}</span>
        </div>
        <div className="absolute bottom-2 right-2">
          <div className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
            <i className="ri-play-fill text-lg"></i>
          </div>
        </div>
      </div>
      <h3 className="text-sm md:text-base font-medium text-foreground-900 line-clamp-1 group-hover:text-primary-600 transition-colors mb-1">
        {video.title}
      </h3>
      <div className="flex items-center gap-2 text-xs text-foreground-500">
        <span>{video.episodeCount}</span>
        <span className="w-1 h-1 rounded-full bg-foreground-400"></span>
        <span>{video.year}</span>
      </div>
    </Link>
  );
}